
import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import { format, parseISO } from 'date-fns';
import './Dividendcopaction.css';
import Pagination from '../../../CommonUI/Pagination/Pagination';
import CorporateActOption from "../../CorporateActOption/CorporateActOption";
import CallTrackApi from "../../../Activity_Track/CallTrackApi";


function Dividendcopaction() {
    const [data, setData] = useState([]);
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [DateDividenddrop, setDateDividenddrop] = useState(new Date().getFullYear());
    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi, getDataHoldingdropDate, item;
    let PageSize = 8;


    useEffect(() => {
        window.scrollTo(0, 0)
        // if (groupValue === "BSE") {
        const getUrl = BaseURL + "Dividendcopaction";
        fetch(`${getUrl}/${DateDividenddrop}/-`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);

                // console.log(getData, "getData")

            })
            .catch((error) => {
            });


        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                // console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, [DateDividenddrop]);


    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);

    CallTrackApi("Dividend",window.location.href);


    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Dividend</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='Dividendcop-loser-sc'>
                            <div className='Dividendcop-header'>
                                <h2><span>Dividend</span></h2>
                            </div>
                            <CorporateActOption optionCorp="Dividend" />
                            <div className='Dividendcop-right'>
                                <div className='Dividendcop-inner-select'>
                                    
                                    {/* aria-label="dividend date " */}
                                    <select aria-label="dividend date" onChange={(event) => { setDateDividenddrop(event.target.value) }}>
                                        <option value={new Date().getFullYear()}>{new Date().getFullYear()}</option>
                                        <option value={new Date().getFullYear() - 1}>{new Date().getFullYear() - 1}</option>
                                        <option value={new Date().getFullYear() - 2}>{new Date().getFullYear() - 2}</option>
                                        <option value={new Date().getFullYear() - 3}>{new Date().getFullYear() - 3}</option>
                                        <option value={new Date().getFullYear() - 4}>{new Date().getFullYear() - 4}</option>
                                        <option value={new Date().getFullYear() - 5}>{new Date().getFullYear() - 5}</option>
                                        <option value={new Date().getFullYear() - 6}>{new Date().getFullYear() - 6}</option>
                                        <option value={new Date().getFullYear() - 7}>{new Date().getFullYear() - 7}</option>
                                        <option value={new Date().getFullYear() - 8}>{new Date().getFullYear() - 8}</option>
                                        <option value={new Date().getFullYear() - 9}>{new Date().getFullYear() - 9}</option>
                                        <option value={new Date().getFullYear() - 10}>{new Date().getFullYear() - 10}</option>
                                    </select>
                                </div>
                            </div>

                            <div className='Dividendcop-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className="text-left">Company Name</th>
                                            <th className="text-left">Dividend Type</th>
                                            <th className="text-right">Dividend %</th>
                                            <th className="text-right">Dividend Amount</th>
                                            <th className="text-right">Announcement Date</th>
                                            <th className="text-right">Record Date</th>
                                            <th className="text-right">Ex-Dividend Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ co_name, DivType, DivPer, AnnDate, RecordDate, xDivDate,divamt }) => (
                                                <tr>
                                                    <td className="text-left">{co_name}</td>
                                                    <td className="text-left">{DivType}</td>
                                                    <td className="text-right">{DivPer}</td>
                                                    <td className="text-right">{divamt}</td>
                                                    <td className="text-right">{(AnnDate != null) ? (format(parseISO(AnnDate), 'dd-MMM-yyyy')) : ''}</td>
                                                    <td className="text-right">{(RecordDate != null) ? (format(parseISO(RecordDate), 'dd-MMM-yyyy')) : ''}</td>
                                                    <td className="text-right">{(xDivDate != null) ? (format(parseISO(xDivDate), 'dd-MMM-yyyy')) : ''}</td>

                                                </tr>
                                            )
                                        )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Dividendcopaction;